export default __webpack_public_path__ + "static/media/code2gather.3a8a7db1.png";